module.exports = __webpack_public_path__ + "static/img/icon-1.e48f0d6a.png";